import { Tag } from "primereact/tag";

import { EquipeAviso } from "../equipe-aviso";
import { EquipeDialog } from "../equipe-dialog";
import {
  EQUIPE_ADDED_LABEL,
  EQUIPE_INCOMPLETA_BACK,
  EQUIPE_INCOMPLETA_INTRO_BEFORE,
  EQUIPE_INCOMPLETA_NONE,
  EQUIPE_INCOMPLETA_PAPEIS,
  EQUIPE_INCOMPLETA_PENDING,
  EQUIPE_INCOMPLETA_SUBTITLE,
  EQUIPE_INCOMPLETA_TITLE,
} from "../equipe-obra.constants";
import styles from "./equipe-incompleta-dialog.module.scss";
import type {
  EquipeIncompletaDialogProps,
  EquipeIncompletaDialogViewModel,
} from "./types-equipe-incompleta-dialog";

/**
 * Modal "Equipe incompleta" (Figma 12227:420586): papéis obrigatórios sem profissional definido. Salvar
 * mesmo assim segue (a pendência nasce ao salvar); sem o X do cabeçalho, o Esc continua voltando.
 */
export function EquipeIncompletaDialogView({
  onHide,
  onConfirm,
  aberto,
  papeis,
  obraRotulo,
  introDepois,
  confirmarLabel,
  aviso,
}: EquipeIncompletaDialogProps & EquipeIncompletaDialogViewModel) {
  return (
    <EquipeDialog
      visible={aberto}
      dialogTestId="equipe-obra-incompleta"
      testId="equipe-obra-incompleta"
      title={EQUIPE_INCOMPLETA_TITLE}
      subtitle={EQUIPE_INCOMPLETA_SUBTITLE}
      voltarLabel={EQUIPE_INCOMPLETA_BACK}
      confirmarLabel={confirmarLabel}
      onVoltar={onHide}
      onConfirmar={onConfirm}
    >
      <p className={styles.intro}>
        {EQUIPE_INCOMPLETA_INTRO_BEFORE}
        <strong>{obraRotulo}</strong>
        {introDepois}
      </p>

      <section className={styles.secao}>
        <h3 className={styles.secaoTitulo}>{EQUIPE_INCOMPLETA_PAPEIS}</h3>
        <ul className={styles.lista}>
          {papeis.map((papel) => (
            <li key={papel.id} className={styles.papel}>
              <div className={styles.info}>
                <div className={styles.titulo}>
                  <span className={styles.nome}>{papel.nome}</span>
                  {papel.limite ? <Tag severity="warning" value={papel.limite} /> : null}
                </div>
                <p className={papel.adicionado ? styles.pessoa : styles.pessoaVazia}>
                  {papel.adicionado ? (papel.profissional ?? "—") : EQUIPE_INCOMPLETA_NONE}
                </p>
              </div>
              <Tag
                severity={papel.adicionado ? "success" : "danger"}
                value={papel.adicionado ? EQUIPE_ADDED_LABEL : EQUIPE_INCOMPLETA_PENDING}
              />
            </li>
          ))}
        </ul>
      </section>

      <EquipeAviso severity="warn" role="status">
        {aviso}
      </EquipeAviso>
    </EquipeDialog>
  );
}
